import { render, staticRenderFns } from "./VesselInfo.vue?vue&type=template&id=3b1f91b3&scoped=true"
import script from "./VesselInfo.vue?vue&type=script&lang=js"
export * from "./VesselInfo.vue?vue&type=script&lang=js"
import style0 from "./VesselInfo.vue?vue&type=style&index=0&id=3b1f91b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f91b3",
  null
  
)

export default component.exports